import React, { Component } from 'react';
import {connect} from 'react-redux';
import { addSecSubOptionBySubQuestion, emptyDemographicsSecSubOption, updateOptionByQuestion, } from '../../actions/demographics';
import AddSecSubOption from '../../components/demographics/addSecSubOption';

class AddDemoSecSubOption extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
      this.quesId = this.queryString.split("/&q:")[1].split('/')[0];  
      this.subQuesId = this.queryString.split("/&sq:")[1].split('/')[0];
      this.secSubQuesId = this.queryString.split("/&ssq:")[1].split('/')[0];
    }

    this.state={
      quesId : this.quesId,
      subQuesId : this.subQuesId,
      secSubQuesId : this.secSubQuesId
    };

    this.addSecSubOptionBySubQuestion = this.addSecSubOptionBySubQuestion.bind(this);
    this.emptyDemographicsSecSubOption = this.emptyDemographicsSecSubOption.bind(this);
  }

  componentDidMount(){
    
  }

  addSecSubOptionBySubQuestion(data){
    this.props.dispatch(addSecSubOptionBySubQuestion(data));
  }

  emptyDemographicsSecSubOption( ){
    this.props.dispatch(emptyDemographicsSecSubOption());
  }
  

  render(){

    let showAddOptionView = "";
    if(this.state.quesId){
         showAddOptionView = <AddSecSubOption
         quesId = {this.state.quesId}
         subQuesId = {this.state.subQuesId}
         secSubQuesId = {this.state.secSubQuesId}
         addSecSubOptionBySubQuestion = {this.addSecSubOptionBySubQuestion}

         demoGraphicsSecSubOptionAddSuccess = {this.props.demoGraphicsSecSubOptionAddSuccess}
         demoGraphicsSecSubOptionSuccessmessage = {this.props.demoGraphicsSecSubOptionSuccessmessage}
         demoGraphicsSecSubOptionFailmessage = {this.props.demoGraphicsSecSubOptionFailmessage}

         emptyDemographicsSecSubOption = {this.emptyDemographicsSecSubOption}
      />
    }
      
    return (
        <div> 
             {showAddOptionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    demoGraphicsSecSubOptionAddSuccess : state.demographics.demoGraphicsSecSubOptionAddSuccess,
    demoGraphicsSecSubOptionSuccessmessage : state.demographics.demoGraphicsSecSubOptionSuccessmessage,
    demoGraphicsSecSubOptionFailmessage : state.demographics.demoGraphicsSecSubOptionFailmessage,    
  }
}

export default connect(mapStateToProps)(AddDemoSecSubOption);



// WEBPACK FOOTER //
// ./src/pages/demographics/addSecSubOption.js